/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {
    CANCEL: 'Ακύρωση',
    CONFIRM: 'Επιβεβαίωση',
    NEW_INVOICE: 'Νέο τιμολόγιο'
  },
  ERROR: {
    ACCUMULATE_SUBMITTED: 'Σφάλμα υποβολής συσσώρευσης',
    CANCEL_ACCUMULATION: 'Σφάλμα κατά την ακύρωση δεδουλευμένων',
    CANCEL_INVOICE: 'Σφάλμα κατά την ακύρωση τιμολογίου',
    COUPON_CANCELED: 'Σφάλμα κατά την ακύρωση του κουπονιού',
    COUPON_GENERATED: 'Σφάλμα δημιουργίας κουπονιού',
    ERROR: 'Σφάλμα',
    INVOICE_SUBMITTED: 'Σφάλμα υποβολής τιμολογίου'
  },
  HEADER: {
    ACCU_REMUNERATION: 'Αμοιβή Acu.',
    ATTACHMENT: 'Παράρτημα',
    CHALLENGE: 'Πρόκληση',
    COUPON: 'Κουπόνι',
    COUPON_CODE: 'Κωδικός κουπονιού',
    DECISION: 'Απόφαση',
    MONTH: 'Μήνας',
    OBSERVATIONS: 'Παρατηρήσεις',
    REMUNERATION: 'Αποδοχές',
    STATE: 'Κράτος',
    SUBMISSION_DATE: 'Ημερομηνία Υποβολής'
  },
  LABEL: {
    ACCUMULATE: 'Συγκεντρώστε',
    ACCUMULATED: 'Αθροιστικό',
    ACTIVES: 'Ενεργό',
    ALL: 'Όλα',
    BEGIN_DATE: 'Ημερομηνία έναρξης',
    CANCEL: 'Ακύρωση',
    CANCEL_ACCUMULATION: 'Ακύρωση συσσώρευσης',
    CANCEL_COUPON: 'Ακύρωση κουπονιού',
    CANCEL_INVOICE: 'Ακύρωση τιμολογίου',
    CLOSE: 'Κλείστε το',
    CODE: 'Κωδικός',
    CONFIRM: 'Επιβεβαίωση',
    CONFIRM_ACCUMULATE: 'Συγκεντρώστε',
    CONFIRM_COUPON_CREATION: 'Δημιουργία κουπονιού',
    CONFIRM_SUBMIT_INVOICE: 'Στείλτε',
    COPY_COUPON_CODE: 'Αντιγραφή κώδικα',
    COUPON: 'Κουπόνι',
    COUPON_CODE: 'Κωδικός κουπονιού',
    CURRENT_PERIOD: 'P. corr.',
    DATE: 'Ημερομηνία',
    DESCRIPTION: 'Περιγραφή',
    END_DATE: 'Ημερομηνία λήξης',
    FILTER: 'Φίλτρο',
    GENERATE_COUPON: 'Δημιουργία κουπονιού',
    GO_TO_DETAILS: 'Δείτε τα προϊόντα',
    INVOICE: 'Τιμολόγιο',
    MODEL: 'Μοντέλο',
    MONEY: 'Χρήματα',
    MONTH: 'Μήνας',
    NEW_INVOICE: 'Νέο τιμολόγιο',
    PAYMENT_METHOD: 'Μέθοδος πληρωμής',
    PENDING_COUNTERPARTS: 'Εκκρεμούν αντισυμβαλλόμενα μέρη',
    PENDING_COUNTERPARTS_MODAL_TITLE:
      'Υπάρχουν αντίστοιχα που δεν έχουν ακόμη επικυρωθεί',
    PENDING_VALUE: 'Ποσό προς τιμολόγηση',
    PREVIOUS_PERIOD: 'P. ant.',
    REMUNERATION: 'Αποδοχές',
    SELECTED_PRODUCTS: 'Επιλεγμένα προϊόντα',
    STATE: 'Κράτος',
    SUBMIT_INVOICE_ATTACHMENT: 'Συνημμένα (PDF)',
    SUBMIT_INVOICE_COMMENT: 'Σχόλιο',
    SUBMIT_MANUAL_REMUNERATION_INVOICE_VALUE: 'Αξία',
    WITHOUT_PRODUCTS: 'Δεν υπάρχουν επιλεγμένα προϊόντα',
    YEAR: 'Έτος'
  },
  SENTENCE: {
    CANCEL_ACCUMULATION:
      'Είστε σίγουρος ότι θέλετε να ακυρώσετε τη συσσώρευση;',
    CANCEL_COUPON: 'Είστε σίγουροι ότι θέλετε να ακυρώσετε το κουπόνι {value}?',
    CANCEL_INVOICE:
      'Είστε σίγουροι ότι θέλετε να ακυρώσετε την υποβολή του τιμολογίου;',
    CANT_GENERATE_COUPON: 'Δεν μπορεί να παράγει κουπόνια.',
    CANT_SUBMIT_REMUNERATION: 'Δεν μπορείτε να υποβάλετε τιμολόγιο.',
    CONFIRM_SUBMIT_COUPON:
      'Δημιουργείτε ένα κουπόνι για το {couponValue}. Θέλετε να ολοκληρώσετε αυτή την ενέργεια;',
    EMPTY_TITLE: 'Δεν υπάρχουν αποτελέσματα'
  },
  SUCCESS: {
    ACCUMULATE_SUBMITTED: 'Συσσωρευμένες αποδοχές',
    CANCEL_ACCUMULATION: 'Ακυρωμένο δεδουλευμένο',
    CANCEL_INVOICE: 'Ακύρωση τιμολογίου',
    COUPON_CANCELED: 'Το κουπόνι ακυρώθηκε',
    COUPON_COPIED: 'Κωδικός κουπονιού που αντιγράφηκε',
    COUPON_GENERATED: 'Το κουπόνι παράγεται με τον κωδικό %{value}',
    INVOICE_SUBMITTED: 'Υποβληθέν τιμολόγιο',
    SUCCESS: 'Επιτυχία'
  },
  TOOLTIP: {
    ACCU_REMUNERATION: 'Αμοιβή Acu.',
    ATTACHMENT: 'Παράρτημα',
    CHALLENGE: 'Πρόκληση',
    COUPON: 'Κουπόνι',
    COUPON_CODE: 'Κωδικός κουπονιού',
    DECISION: 'Απόφαση',
    MONTH: 'Μήνας',
    OBSERVATIONS: 'Παρατηρήσεις',
    REMUNERATION: 'Αποδοχές',
    STATE: 'Κράτος',
    SUBMISSION_DATE: 'Ημερομηνία υποβολής',
    SWIPE:
      'Σύρετε το δάχτυλο προς τα αριστερά για να δείτε περισσότερες στήλες.',
    VIEW_CHALLENGE_DETAILS: 'Δείτε τις λεπτομέρειες της πρόκλησης'
  }
};
